import * as d3 from "d3";

export const parseSystemDate = (input) => new Date(input);

export const parseFloatOrNull = (value) =>
  value === "n/a"
    ? null
    : value.endsWith("%") === true
    ? parseFloat((parseFloat(value.trim("%")) / 100).toFixed(4))
    : parseFloat(value);

const dateTimeParser = d3.timeParse("%Y-%m-%dT%H:%M:%S");

const parseKeys = (head, translations = {}) =>
  head.split(/\s+/).map((key) => translations[key] || key);

const timeAndNumbers = (row, keys, skipped = []) =>
  row
    .split(/\s+/)
    .map((value, index) =>
      skipped.length > 0 && skipped.includes(keys[index])
        ? null
        : [
            keys[index],
            index > 0 ? parseFloatOrNull(value) : dateTimeParser(value),
          ]
    )
    .filter((item) => item !== null);

export const fixedPrecision = (value, decimals = 4) =>
  parseFloat(value.toFixed(decimals));

const appendSeries = (series, key, value, valueName = "value") =>
  series === undefined || series.length === 0
    ? [{ name: key, value: value }]
    : [...series, { name: key, [valueName]: value }];

const asIts = (value) => value;

const toFactList =
  (skipped, valueName = "value", valueFormat = asIts) =>
  (reading, [key, value]) =>
    skipped.includes(key) === true
      ? reading
      : key === "time" || key === "total" || key === "dpi"
      ? { ...reading, [key]: value }
      : {
          ...reading,
          series: appendSeries(
            reading.series,
            key,
            valueFormat(value),
            valueName
          ),
        };

const parseHourly = (
  input,
  translations = {},
  skipped = [],
  valueFormat = asIts
) => {
  const lines = input.length === 0 ? [] : input.trim().split("\n");
  if (lines.length === 0) {
    return [];
  }
  const [head, ...rows] = lines;
  const keys = parseKeys(head, translations);
  return rows.map((row) =>
    timeAndNumbers(row, keys, skipped, translations, valueFormat).reduce(
      toFactList(skipped, "value", valueFormat),
      {}
    )
  );
};

const bitsToMb = (bits) => bits / 1000000;
export const parseVolumeHourly = (input) => {
  const translations = {
    TIME: "time",
    "IN-BYTES": "In",
    "OUT-BYTES": "Out",
  };
  const skipped = ["NUM-DETECT", "NUM-COMP", "%RATIO"];
  const valueFormat = bitsToMb;
  return parseHourly(input, translations, skipped, valueFormat);
};

export const parseRatioHourly = (input) => {
  const translations = {
    TIME: "time",
    "%RATIO": "Compression Ratio",
  };
  const skipped = ["NUM-DETECT", "NUM-COMP", "IN-BYTES", "OUT-BYTES"];
  return parseHourly(input, translations, skipped);
};
